"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const ListItem_1 = tslib_1.__importDefault(require("@mui/material/ListItem"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
/**
 * Takes a string "title" as the only required prop.
 * Also supports a second string "substring" and an avatar if it's included in the props
 * @param title The main content, often used as a full name
 * @param subTitle Optional secondary string, could be used for example to show what company the name is connected to
 * @param avatar An optional ReactNode that will render an avatar if provided.
 * @returns a custom option  based the input props, for the Autocomplete components
 * @category component
 */
const AutocompleteOption = ({ title, subTitle, avatar, ...rest }) => (react_1.default.createElement(ListItem_1.default, { ...rest },
    react_1.default.createElement("div", { style: { display: "flex", alignItems: "center" } },
        avatar || null,
        react_1.default.createElement("div", null,
            react_1.default.createElement(Typography_1.default, { variant: "subtitle1" }, title),
            subTitle && react_1.default.createElement(Typography_1.default, { color: "textSecondary" }, subTitle)))));
exports.default = AutocompleteOption;
